module.exports = __webpack_public_path__ + "img/77_M19.a421253a.jpg";